import {Component, OnDestroy, AfterViewInit, ViewChild} from '@angular/core';
import {MapComponent} from './map.component';
import {Subject} from 'rxjs';
import {MapService} from '../../commons/map.service';
import {EPSGCodes, FourDService, Annotation} from '4d-mapper';
import { MeasurementHelperService } from '../../service/measurement-helper.service';
import { Constants } from '../../commons/Constants';
import { EpsgHelperService } from '../../service/epsg-helper.service';
import { EntityHelperService } from '../../service/entity-helper.service';
import { AnnotationType, AnnotationStyle } from '../../commons/global';

import * as _ from 'lodash'
import { CoordGeodetic, CoordHelperService } from '../../service/coord-helper.service';
import { TranslateService } from '@ngx-translate/core';
import { XsIdentityInterface } from '@src/app/xs/interfaces/identify.interface';
import { XsEventListenerInterface } from '@src/app/xs/interfaces/event-listener.interface';
import { XsApplicationEventsService } from '@src/app/xs/services/events/application-events.service';
import { BaseComponent } from '@src/app/commons/BaseComponent';
import { OnInit } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { XsAwait } from '@src/app/xs/controllers/await.class';
import { CompositeEntityCollection } from 'cesium';
import { UiManagerService } from '@src/app/xs/services/ui/ui-manager.service';


const Cesium = (<any>window).Cesium

@Component({
  selector: 'position-nav',
  template: `
    <div id="show-coordinates">
      <div *ngIf="cartographic && showCoordinates">
      <fa-icon icon="map-marked-alt" style="color:orange" [matTooltip]="'MAP.CURSOR' | translate"></fa-icon>
        <small class="ml-2" [matTooltip]="'MAP.HEIGHT_CAPTION' | translate" matTooltipPosition="above">
          <fa-icon icon="arrow-from-bottom" [fixedWidth]="true"></fa-icon>
          <span *ngIf="measurementUnit === FEET">
              {{'MAP.HEIGHT_FEETS' | translate:{height: cartographic.height | round:3} }}
            </span>
          <span *ngIf="measurementUnit !== FEET">
              {{'MAP.HEIGHT_METERS' | translate:{height: cartographic.height | round:3} }}
            </span>
        </small>
        <small class="ml-1 mr-2" *ngIf="vertical_offset" >(<fa-icon [icon]="['fas','arrow-to-bottom']" [fixedWidth]="true" title="Height offset applied"></fa-icon>
          <span *ngIf="measurementUnit === FEET">
              {{'MAP.HEIGHT_FEETS' | translate:{height: vertical_offset | round:3} }}
            </span><span *ngIf="measurementUnit !== FEET">
              {{'MAP.HEIGHT_METERS' | translate:{height: vertical_offset | round:3} }}
            </span>)</small>

        <small [matTooltip]="'MAP.COORD_CAPTION' | translate" matTooltipPosition="above">
          <fa-icon icon="map-marker" [fixedWidth]="true"></fa-icon>
          <span *ngIf="projectedCoordinates">
            {{'MAP.COORD_PROJECTED' | translate: {
              lng: cartographic.longitude | round:3,
              lat: cartographic.latitude | round:3
              }
            }}
          </span>
          <span *ngIf="!projectedCoordinates">
            {{'MAP.COORD_NOT_PROJECTED' | translate: {
                lat: cartographic.latitude | round:7,
                lng: cartographic.longitude | round:7
              }
            }}
          </span>
        </small>
        <small class="ml-2"><fa-icon icon="clock" [fixedWidth]="true"></fa-icon> {{ mapService?.cameralocation?.timeLabel }} [{{ mapService?.cameralocation?.timeZone }}]</small>
        <fa-icon class="ml-2" *ngIf="slowDownZoom" icon="thumbtack" [fixedWidth]="true" title="Locked on 3D tileset (slowed zoom)"></fa-icon>
      </div>

      <div *ngIf="mapService?.cameralocation && showCameraCoordinates">
        <fa-icon icon="camera-movie" style="color:orange" [matTooltip]="'MAP.CAMERA' | translate"></fa-icon>
        <small class="ml-2" [matTooltip]="'MAP.HEIGHT_CAPTION' | translate" matTooltipPosition="above">
          <fa-icon icon="arrow-from-bottom" [fixedWidth]="true"></fa-icon>
          <span *ngIf="measurementUnit === FEET">
            {{'MAP.HEIGHT_FEETS' | translate:{height: mapService?.cameralocation?.height | round:3} }}
          </span>
          <span *ngIf="measurementUnit !== FEET">
              {{'MAP.HEIGHT_METERS' | translate:{height: mapService?.cameralocation?.height | round:3} }}
          </span>
        </small>
        <small class="ml-2" [matTooltip]="'MAP.COORD_CAPTION' | translate" matTooltipPosition="above">
          <fa-icon icon="map-marker" [fixedWidth]="true"></fa-icon>

          <span *ngIf="projectedCoordinates">
            {{'MAP.COORD_PROJECTED' | translate: {
              lng: cartographicCamera.longitude | round:3,
              lat: cartographicCamera.latitude | round:3
              }
            }}
          </span>
          <span *ngIf="!projectedCoordinates">
            {{'MAP.COORD_NOT_PROJECTED' | translate: {
                lat: mapService?.cameralocation?.latitude | round:7,
                lng: mapService?.cameralocation?.longitude | round:7
              }
            }}
          </span>


          <!-- <span *ngIf="projectedCoordinates">
            {{ 'MAP.LONGITUDE' | translate }} {{ mapService?.cameralocation?.longitude }} {{ 'MAP.LATITUDE' | translate }} {{ mapService?.cameralocation?.latitude }}
          </span>
          <span *ngIf="!projectedCoordinates">
            {{ 'MAP.LONGITUDE' | translate }} {{ mapService?.cameralocation?.longitude }} {{ 'MAP.LATITUDE' | translate }} {{ mapService?.cameralocation?.latitude }}
          </span> -->
        </small>
        <small *ngIf="heading" class="ml-2" [matTooltip]="'MAP.HEADING_CAPTION' | translate" matTooltipPosition="above">
          <fa-icon icon="compass" [fixedWidth]="true"></fa-icon>
          {{ 'MAP.HEADING_CAPTION' | translate }} {{ heading }}°
        </small>
      </div><!-- [{{hoverCounter}}] [{{ checked }}] -->
    </div>`
})

// <div style="position:absolute;bottom:5px;left:450px;border:solid 1px red;background-color:orange;height:100px;">projected=[{{ projectedCoordinates }}] type=[{{ CSRType }}] code=[{{ selectedEPSG }}] </div>
// <div style="position:absolute;bottom:115px;left:450px;border:solid 1px red;background-color:yellow;color:#333;height:100px;">prCode=[{{ mapComp.project['EPSGCode'] }}] sourceProjection=[{{ sourceProjection }}] geoProjection=[{{ geographicProjection }}] </div>
//  [{{ cartographic.longitude * 180 / 3.14 }}] [{{ cartographic.latitude * 180 / 3.14 }}]

export class PositionNavComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {

  // refactor; fixing shitty code
  debug:boolean = Constants.debug_off;
  projectedCoordinates:boolean = false;

  hoverInfo:string = '';

  // old code
  private ctx: any;
  measurementUnit: string
  screenSpaceEventHandler: any
  cartesian: any;
  // carto:any;
  cartographic:any = { longitude:null, latitude:null, height:null };
  cartographicCamera:any = { longitude:null, latitude:null, height:null };

  // CSRType:string = 'Projected';
  private sourceProjection: string = null;
  // private selectedEPSG = '4326';
  private geographicProjection: string;
  FEET = MapService.FEET;
  private vertical_offset  = 0;

  // current mouse coord
  mouseCoords:any = null;

  // tolerance mouse coords (for checking mouse movement distances)
  mouseCoordsPrev:any = null;

  // have we checked current position?
  checked:boolean = false;

  // setInterval identifier
  intervalId:any = null;

  // delay counter (introduce some lag for overall performance)
  delayCounter:number = 0;

  // distance counter (for figuring a certain distance moving for gently closing the popup)
  distanceCounter:number = 0;

  // screen ticks; an ongoing counter for doing stuff
  screenTick:number = 0;

  // how many iterations we cache the hover info
  hoverCounter:number = 12; // 1.2 seconds
  hoverCounterMax:number = 20;

  // the shape our information is taken from (if from an Annotation shape collection)
  hoverShape:any = null;

  // for caching purposes we don't action a new hover if it's an old ID
  hoverId:number = null;

  // all the edges for our popup hover infobox
  hoverEntities:any[] = [];

  // are we slowing down zoom? (when we're above a 3D tileset)
  slowDownZoom:boolean = false;

  showLocation:boolean = false;

  showCoordinates:boolean = true;
  showCameraCoordinates:boolean = true;

  heading:string = null;

  deviceOrientationSupported:boolean = false;
  currentScreenOrientation = window.orientation || 0; // active default

  selectedEntity:any = null;
  selectedEntityRendered:boolean = false;

  // pickCartesian:any = null;

  cesiumMapViewer:any = null;

  constructor(
    public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog, public uiManager: UiManagerService,
    private mapComp: MapComponent, private fourD: FourDService, public mapService: MapService, public mapHelper: MeasurementHelperService,
    public epsgHelper: EpsgHelperService, public measureHelper: MeasurementHelperService, public coordHelper: CoordHelperService, 
    public entityHelper: EntityHelperService, private t:TranslateService, public applicationEvents:XsApplicationEventsService
  ) {
    super(router, snackBar, dialog);
    if ( this.debug ) { console.log ( '%c position-nav.component %c CONSTRUCTOR', Constants._red, Constants._white, this ); }
  }

  /* 
    NOTES
    * Moved all picking from here to the measurementService

  */

  destroy(): void {
    // if we're using an interval, kill it
    if ( this.intervalId ) {
      clearInterval(this.intervalId);
    }
    if ( this.mapService.locationShape ) {
      this.cesiumMapViewer.entities.removeById ( this.mapService.locationShape );
      this.mapService.locationShape = null;
    } 
  }


  devicePositionHandler () {

    if ( this.cesiumMapViewer && this.cesiumMapViewer.camera ) {
      let p = this.cesiumMapViewer.camera.positionCartographic;
      this.mapService.cameralocation.longitude = p.longitude * 180 / Math.PI;
      this.mapService.cameralocation.latitude = p.latitude * 180 / Math.PI;
      this.mapService.cameralocation.height = p.height;
    }
    if ( this.fourD && this.fourD.activeUser && this.fourD.activeUser['showLocation'] ) {
      // console.log('@@ pos', navigator.geolocation);
      if ( navigator.geolocation ) {
        navigator.geolocation.getCurrentPosition( ( position ) => {
          // console.log('@@ pos', position);
          this.mapService.geolocation.longitude = position.coords.longitude;
          this.mapService.geolocation.latitude = position.coords.latitude;
          this.mapService.geolocation.height = position.coords.altitude; 
          this.mapService.geolocation.sampledHeight = this.sampleHeight (this.mapService.geolocation);
          this.mapService.geolocation.cameraHeight = Math.round(this.cesiumMapViewer.camera.positionCartographic.height);
        });
      }
    }
  }

  

  sampleHeight ( coords:any ) {
    let coord = new CoordGeodetic( coords );
    let cesiumCoord = coord.toCesiumCartographic();

    let s = this.cesiumMapViewer.scene.sampleHeight(cesiumCoord);
    if ( s ) {
      return s;
    }
    let g = this.cesiumMapViewer.scene.globe.getHeight(cesiumCoord);
    if ( g ) {
      return g;
    }

    var positions = [ cesiumCoord ];
    var promise = Cesium.sampleTerrain(this.cesiumMapViewer.terrainProvider, 11, positions ); 


    Cesium.when(promise, function(updatedPositions) { 
      // console.log('*****!!!!!!', updatedPositions);
      if ( updatedPositions && updatedPositions[0] ) {
        return updatedPositions[0];
      }
    }); 
    return null;

  }

  ngAfterViewInit() {

    if ( this.debug ) { console.log ( '%c position-nav :: init()', Constants._yellow); }

    // this is what we're converting *from*
    this.geographicProjection = 'GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]]';


    // first time initialise
    this.setMUnitAndEPSGCode();

    if (window['DeviceOrientationEvent']) {
      let me = this;
      this.deviceOrientationSupported = true;
      window.addEventListener('deviceorientation', function(e) {
        me.deviceOrientationHandler ( e );
      });
      window.addEventListener('orientationchange', function() {
        me.currentScreenOrientation = window.orientation;
      }, false);
    }
  }

  ___sceneChangeEnd( obj:any = null ) {
    if ( this.debug ) { console.log ( '%c position-nav.component %c ___sceneChangeEnd ', Constants._red, Constants._white, obj ); }
    this.setMUnitAndEPSGCode();
  }

  // listen out for when the mapViewer / CesiumMap is ready (ref; InterconnectedEventsInterface)
  ___mapViewer (obj:any = null ) {

    let me = this;

    if ( this.debug ) { console.log ( '%c position-nav.component %c ___mapViewer ', Constants._red, Constants._white, obj ); }

    XsAwait.until( 'mapService.viewer.dataSourceDisplay', this ).then ( _ => {

        // our local reference to the viewer
        me.cesiumMapViewer = this.mapService.viewer;

        me.afterCesiumViewerSetup();

    });
    
  }    

  ___mapViewerEnd (obj:any = null ) {
    if ( this.debug ) { console.log ( '%c position-nav.component %c ___mapViewerEnd ', Constants._red, Constants._white, obj ); }
  } 

  checkInterval:any = null;
  adminInterval:any = null;

  afterCesiumViewerSetup() {

    // our location marker
    this.mapService.locationShape = this.cesiumMapViewer.entities.add({
      type: 'location',
      position: new Cesium.CallbackProperty( () => {
        return Cesium.Cartesian3.fromDegrees ( 
          this.mapService.geolocation.longitude, 
          this.mapService.geolocation.latitude, 
          this.mapService.geolocation.height ? this.mapService.geolocation.height : ( this.mapService.geolocation.sampledHeight ? this.mapService.geolocation.sampledHeight : this.mapService.geolocation.cameraHeight ),
          )
      }, false),
      show: this.fourD.activeUser && this.fourD.activeUser['showLocation'],
      billboard: {
        image: "assets/images/icons/location.png",
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
      }
    });

    this.checkInterval = setInterval( () => {  
      // are we showing hover info?
      if ( this.fourD && this.fourD.activeUser && this.fourD.activeUser['showHoverPopups'] ) {

        if ( this.hoverCounter > 0 ) {
          this.hoverCounter--;
        }
        if ( this.hoverCounter == 0 && !this.checked ) {
          this.checkForHoverObjects();
        }
      }
    }, 100 );

    this.adminInterval = setInterval ( () => {

      if ( this.fourD && this.fourD.activeUser ) {
        let a = this.fourD.activeUser;
        if ( a.hasOwnProperty('showCoordinates') ) {
          this.showCoordinates = a['showCoordinates'];
        }
        if ( a.hasOwnProperty('showCameraCoordinates') ) {
          this.showCameraCoordinates = a['showCameraCoordinates'];
        }
      };

    }, 1200 );

    this.screenSpaceEventHandler = new Cesium.ScreenSpaceEventHandler(this.cesiumMapViewer.scene.canvas);

    // get the vertical_offset value for the 3D tileset on mouse click, then use it for better adjusting the slowDownMouse
    /*
    this.screenSpaceEventHandler.setInputAction((movement) => {

      var pickedObject = this.measureHelper.pickedModel; // this.mapService.viewer.scene.pick(movement);
      if (pickedObject && (pickedObject.primitive instanceof Cesium.Cesium3DTileset) ){
        let check = this.measureHelper.checkMousePosition (movement);
        check.vertical_offset;
      } else {
        this.vertical_offset=0;
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
*/
    this.cesiumMapViewer.scene.preRender.addEventListener((info) => {

      // note: Cesium have some issue where a combination of picking happens, the pickPosition() needs to
      // be first in a fresh render, hence this odd storing of a position
      // if ( this.mapService && this.mapService.viewer && this.mouseCoords ) {
      //   this.pickCartesian = this.mapService.viewer.scene.pickPosition(this.mouseCoords);
      // }

      if ( this.screenTick++ > 200 ) {
        this.screenTick = 0;
        this.devicePositionHandler();
      };

    });

    

    // set up a mouse handler for movements
    this.screenSpaceEventHandler.setInputAction((movement) => {

      if (movement.endPosition && this.cesiumMapViewer.scene ) {

        this.mouseCoords = movement.endPosition;

        if ( ! this.mouseCoordsPrev ) {
          this.mouseCoordsPrev = _.clone(movement.endPosition);
          // console.log ('!',this.mouseCoordPrev);
        }

        let testx = Math.round ( Math.abs ( this.mouseCoords.x - this.mouseCoordsPrev.x ) ); 
        let testy = Math.round ( Math.abs ( this.mouseCoords.y - this.mouseCoordsPrev.y ) ); 

        if ( testx > 3 || testy > 3 ) {
          this.mouseCoordsPrev = _.clone(movement.endPosition);
          this.hoverCounter = this.hoverCounterMax;
          this.checked = false;
          this.distanceCounter++;

          if ( this.distanceCounter > 8 ) {
            this.distanceCounter = 0;
            this.delayedResetHover();
          }

          this.heading = (this.cesiumMapViewer.camera.heading * 180 / Math.PI).toFixed(1);

            var found = false;
            let pickedObjects = this.pickObjects();
            
            
            if ( pickedObjects ) {

              // loop through all found objects, looking for 3DTilesets
              pickedObjects.forEach(pickedObject => {
                if (pickedObject ) {

                  if ( pickedObject.primitive instanceof Cesium.Cesium3DTileset ) {

                    this.selectedEntity = pickedObject.primitive;

                    found = true;
                    // this.vertical_offset=;
                    if ( pickedObject.primitive['transform_id'] ) {

                      // pickedObject.primitive.silhouetteSize = 1;
                      
                      // setTimeout( () => { pickedObject.primitive.silhouetteSize = 0; }, 2000 );
                      let t = this.mapService.sceneTransforms.find ( tt => tt.id == pickedObject.primitive['transform_id']);
                      if ( t ) {
                        this.vertical_offset=t['vertical_offset'];
/*
                        let cart = this.pickCartesian;
                        let carto = null;
                        if ( cart ) {
                          carto = Cesium.Cartographic.fromCartesian( cart );
                          carto.longitude = carto.longitude * 180 / Math.PI;
                          carto.latitude = carto.latitude * 180 / Math.PI;
                          // carto.height = carto.height - this.vertical_offset;
                        }
                        console.log ( '!!!', this.mouseCoords, cart, carto );
*/
                      }
                    }
                    
                  }
                } 
              });
            }
            
            if ( found ) {
              //slow down if 3d tiles detected
              this.cesiumMapViewer.scene.screenSpaceCameraController._zoomFactor = 0.95;
              this.cesiumMapViewer.scene.screenSpaceCameraController.inertiaSpin =0.7;
              this.cesiumMapViewer.scene.screenSpaceCameraController.inertiaTranslate  =0.7;
              this.slowDownZoom = true;
/*
              if ( this.selectedEntity && this.selectedEntity['transform_id'] ) {

                let tid = this.selectedEntity['transform_id'];
                let t = this.mapService.sceneTransforms.find( st => st.id == tid );
                console.log( '$$$$$$$$$$$$$$$ TRANSFORM', tid, t );
                if ( t ) {
                  let obj = this.mapService.helper.getMapObjectFor( t );
                  console.log( '$$$$$$$$$$$$$$$ TRANSFORM FOUND', obj );
                  if ( obj.boundingSphere ) {
  
                    let entityCoord = obj.boundingSphere.center
      
                    const screen = Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.cesiumMapViewer.scene, entityCoord );
      
                    this.mapService.debugData = screen.x + ',' + screen.y;
                  }
                }
                
              } else {
                this.mapService.debugData = null;
              }

              if ( ! this.selectedEntityRendered ) {

                let positions = null;

                if ( this.selectedEntity._root ) {
                  positions = this.traverseTiles ( this.selectedEntity._root );
                  // let bb = Cesium.OrientedBoundingBox.fromPoints( positions );
                  console.log( '$$$$$$$$$$$$$$$ TRAVERSE', positions );
                }

                let hull = this.coordHelper.createHullCartesian3 ( positions );
                // create a loop
                hull.push( hull[0] );
                console.log( '$$$$$$$$$$$$$$$ HULLING', hull );
                
                this.selectedEntityRendered = this.mapService.viewer.entities.add({
                  polyline: {
                    positions: hull,
                    width: 4.0,
                    loop: true,
                    material: new Cesium.PolylineDashMaterialProperty({
                      color: Cesium.Color.ORANGE.withAlpha(0.8)
                    }),
                    depthFailMaterial: new Cesium.PolylineDashMaterialProperty({
                      color: Cesium.Color.ORANGE.withAlpha(0.5)
                    }),
                  }
                });
                let me = this;
                setTimeout( ()=>{ me.mapService.viewer.entities.remove (me.selectedEntityRendered); me.selectedEntityRendered=null; }, 4000 );
                
              } */

            } else {
              //set to default if no 3d tiles detected
              this.cesiumMapViewer.scene.screenSpaceCameraController._zoomFactor = 1;
              this.slowDownZoom = false;
              this.vertical_offset=0;
            }

          // }

          this.cartesian = this.measureHelper.pickedCartesian;

          this.setScreenCoords(this.cartesian);

        }
      }

    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    this.mapService.projectSettingMeasurementUnitChanged.subscribe(v => {
      this.measurementUnit = v;
    });
    this.mapService.projectSettingEPSGCodeChanged.subscribe(v => {
      this.setEpsgCode(v, true);
    });
  }

  traverseTiles ( tile:any = null, ret:any = [], depth:number = 0 ) {

    if ( tile && tile._boundingVolume && tile._boundingVolume._boundingSphere ) {
      ret.push( tile._boundingVolume._boundingSphere.center );
    }
    
    if ( tile && tile.children ) {
      tile.children.forEach(t => {
        ret = this.traverseTiles ( t, ret, depth + 1);
      });
    }

    return ret;
  }

  pickObjects() {

    // if ( this.mouseCoords && this.mapService && this.mapService.viewer && this.mapService.viewer.scene ) {
      // console.log ( '!!!', this.mouseCoords);
      // let test = this.mapService.viewer.scene.drillPick(this.mouseCoords,3, 10, 10);
      // console.log ( '!!! @@@', test);
      return this.measureHelper.pickedModels;
    // }
    // return null;
  }

  // convert a string with lines and kolons into an array of key/value objects
  createProps ( t:string ) {
    let ret = [];
    let lines = t.split('\n');
    lines.forEach( l => {
        let s = l.split(':');
        ret.push({key: s[0], value: s[1] });
    });
    return ret;
  }


  checkForHoverObjects() {
    
    // console.log ( 'checkForHoverObjects()', this.measureHelper );

    let pickedObjects = this.pickObjects();
    let found = null;
    let me = this;

    this.checked = true;

    if ( pickedObjects && pickedObjects.length ) {

      // console.log ( 'checkForHoverObjects() picked_objects', pickedObjects );

      pickedObjects.forEach(pickedObject => {
        if (pickedObject && ! found ) {
          // console.log ( 'hoverObjects picked', pickedObject);
          if ( this.checkHoverObject( pickedObject ) ) {
            found = 'yes';
          };
        } 
      });

    } else {

      // also check for image layers
      if ( this.mapService.viewer && this.mapService.viewer['scene'] && this.mapService.viewer['imageryLayers'] && this.mapService.viewer['camera'] && this.measureHelper.lastMousePosition && this.fourD.activeUser ) {

        this.cesiumMapViewer = this.mapService.viewer;
        
        const pickRay = this.cesiumMapViewer.camera.getPickRay(this.measureHelper.lastMousePosition);

        if ( this.fourD.activeUser['showHoverPopupsImageFeatures'] ) {
          var featuresPromise = this.cesiumMapViewer.imageryLayers.pickImageryLayerFeatures(pickRay, this.cesiumMapViewer.scene);
          if (Cesium.defined(featuresPromise)) {

            // found features
            found = 'promise';

            Cesium.when(featuresPromise, function(features) {

              let f = features[0];

              // console.log('ImageLayer feature', features );

              if ( f ) {
                let props = me.getEntityProperties(f);
                // console.log('ImageLayer feature RESULT', f, props );
                me.selectHoverObject (f);
                found = 'yes';
                me.openHover ({ show:true, accent:true, coord: me.cartesian, image: null, text: null, props: props });
              } else {
                found = null;
              }
              this.checkForHoverObjectsEnd(found);
            });
          }
        }

        if ( this.fourD.activeUser['showHoverPopupsImageLayers'] ) {
          let layers = this.cesiumMapViewer.imageryLayers.pickImageryLayers(pickRay,this.cesiumMapViewer.scene);
          if ( layers && layers.length ) {
            layers = layers.filter( f => !f._isBaseLayer && f['transform_id'] );
          }
          let layer = null;
          if ( layers && layers.length ) {
            layer = layers[0];
          }
  
          // console.log('ImageLayer layer', layer );
  
          if ( layer ) {
            let t = this.mapService.sceneTransforms.find ( tt => tt.id == layer['transform_id'] );
            if ( t ) {
              let props = [{ key:'Name',value:t['name']},{key:'type',value:t['ds_type_uid']} ];
              this.selectHoverObject ( layers[0] );
              found = 'yes';
              this.openHover ({ show:true, accent:true, coord: this.cartesian, image: null, text: null, props: props });
            }
          }
        }
      }
    }

    // if a promise, skip this as the Promise will call it when ready
    if ( found !== 'promise' ) {
      this.checkForHoverObjectsEnd(found);
    }
  }

  checkForHoverObjectsEnd ( found:any ) {
    if ( !found ) {
      this.delayedResetHover();
    }
  }

  findAnnotation ( a:Annotation, lookingFor:any = null ) {
    if ( this.mapService && this.mapService.annotations ) {
      return this.mapService.annotations.find( a => a.id == lookingFor );
    }
    return null;
  }

  checkHoverObject ( pickedObject:any ) : boolean {

    // if ( pickedObject.primitive ) {
    //   pickedObject = pickedObject.primitive;
    // }
    
    let entity = pickedObject instanceof Cesium.Cesium3DTileFeature ? pickedObject : ( pickedObject.id ? pickedObject.id : null );
    // let entity2 = pickedObject instanceof Cesium.Cesium3DTileset;
    // console.log ( 'hover check entity', pickedObject, entity );
    
    //if ( entity && entity2 ) {
    //  entity['type'] = 'tileset';
    //}

    // console.log ( 'hover check', pickedObject, entity );

    // has it got an id object? (or is a 3DTileFeature)
    if ( entity ) {
      
      let type = pickedObject instanceof Cesium.Cesium3DTileFeature ? 'props' : entity['type'];
      if ( !type ) {
        if ( pickedObject instanceof Cesium.Cesium3DTileset ) { type = 'tileset'; }
      }
      let hasTransform = pickedObject['transform_id'];

      let id = ( type == 'props' ? entity._batchId : entity.id );
      if ( !id ) {
        id = hasTransform;
      }
      let a = null;
      let props = null;

      // console.log ( 'hover type=['+type+']', id, hasTransform );
  
      //console.log ( 'hover id', id );

      if ( type !== 'edge' ) {

        if ( id == this.hoverId ) {
          return true;
        }

        if ( pickedObject instanceof Cesium.Cesium3DTileFeature ) {

          this.hoverId = id;
          this.hoverCounter = this.hoverCounterMax;
          
          var propertyNames = pickedObject.getPropertyNames();
          var length = propertyNames.length;
          var culledLength = 0;
          let these = [];
          
          for (var i = 0; i < length; ++i) {
              var propertyName = propertyNames[i];
              let p = pickedObject.getProperty(propertyName);
              if ( p ) {
                culledLength++;
                these.push({ key: propertyName, value: p });
                // console.log(propertyName + ': ' + p);
              }  
          }
          these.push({key:'meta',value:'type=3DTileFeature id='+id+' props='+culledLength+' of '+length });
          //console.log('!!', pickedObject, length, these );
          // console.log ( 'hover check TILESET FEATURE', id, these );
          if ( these.length > 0 ) {
            this.openHover ( { show:true, accent:true, coord: this.cartesian, image:null, text: null, props: these });
            return true;
          }
          
        } else if ( type == 'tileset' ) {
          let t = this.mapService.sceneTransforms.find ( tt => tt.id == id );
          // if ( t ) {}
          // console.log ( 'hover check TILESET', id, t );
        }

      }

      // quickly check for properties for a given entity
      props = this.entityHelper.getEntityProperties ( id );
      // console.log ( 'hover check PROPS', props );

      // some entities have an older fourd_ref reference to an annotation
      if ( entity['fourd_ref'] ) {
        // console.log ( 'hover check FOURD_REF CHECK', entity['fourd_ref'] );
        a = this.findAnnotation( a, entity['fourd_ref'] );
        if ( a && a['annotationMode'] ) {
          type = a['annotationMode'];
        }
        // console.log ( 'hover check FOURD_REF', type, a );
      }

      
      
      // didn't have an old reference, so try a new one from the properties
      if ( !a && props ) {
        if ( props.annotationRef && props.annotationRef > 0 ) {
          // console.log ( 'hover check annotationRef CHECK', props.annotationRef );
          a = this.findAnnotation( a, props.annotationRef );
        } else {
          //console.warn ( 'no annotation reference', props );
        }
      }

      if ( this.debug ) { console.log('$$$ hover', type, a, entity ); }

      // console.log('##hover',type,props,a,entity);

      if ( type == 'line' || type == 'area' || type == 'volume' || type == 'camera' || type == 'poi' || type == 'location' ) {

        if ( type == 'area' || type == 'volume' ) {
  
          if ( a ) {

            // if ( this.mapComp.inspectorComp.selected && a.id == this.mapComp.inspectorComp.selected.id ) {
            //   return true;
            // }

            
            this.hoverShape = a['shapes'][props.shapeRef];

            // we need calculations, including the centroid (to place it)
            if ( this.hoverShape['calc'] && this.hoverShape.calc['centroid'] ) {

              this.selectHoverObject ( entity );

              let props = this.createProps ( this.createCalculatedText ( this.hoverShape.calc, a ) );
              props.push({key:'type',value:type});
              
              this.openHover ( { show:true, accent:true, coord: this.hoverShape.calc.centroid, image:null, text: a.name, props: props });

              return true;

            } else {

              //console.warn ( 'no calc or centroid', this.hoverShape['calc']);

            }
            
          }
          
        } else if ( type == 'location' ) {

          this.selectHoverObject ( entity );

          // console.log ( "!!!!!!!!!!!!!!!!!", entity, entity.position.getValue() );
          this.t.get('NAV.CURRENT_LOCATION').subscribe(s => 
            this.openHover ( { show:true, accent:true, coord: entity.position.getValue(), image: null, text:s, props: [
              { key: 'longitude', value: this.mapService.geolocation.longitude }, 
              { key: 'latitude', value: this.mapService.geolocation.latitude } ,
              { key: 'latitude', value: this.mapService.geolocation.height } ,
            ] })
          )

          return true;

        } else if ( type == 'camera' && entity['camera_id'] ) {

          this.selectHoverObject ( entity );

          let i = this.mapComp.imageComp.images.find( z => z.id == entity['camera_id'] );

          if ( i ) {

            let x = null;
            let y = null;
            if ( i['image'] ) {
              x = i['image']['image_width'];
              y = i['image']['image_height'];
            }
            if ( i['dimensions'] ) {
              x = i['dimensions']['width'];
              y = i['dimensions']['height'];
            }

            this.openHover ( { show:true, accent:true, coord: entity.position._value, image: i, text: null, props: [
              { key: 'name', value: i['ds_name'] },
              { key: 'x,y', value: x + 'px , ' + y + 'px' } ,
              { key: 'longitude', value: i['ulng'] }, 
              { key: 'latitude', value: i['ulat'] }, 
              { key: 'height', value: i['uheight'] }, 
              { key: 'heading', value: i['uheight'] }, 
              { key: 'size', value: this.formatSize(i['size']) }, 
              
            ] });

            return true;
          }

        } else if ( type == 'poi' ) {

          if ( !a ) {
            a = this.findAnnotation( a, entity['fourd_ref'] );
          }

          if ( a ) {

            this.selectHoverObject ( entity );
            
            let props = [];
            props.push( { key: 'name', value: a['name'] } );
            if ( a['desc'] && a['desc'].trim() !== '' ) {
              props.push( { key: 'notes', value: a['desc'] } );
            }
            if ( a['categories'] && a['categories'].length ) {
              props.push( { key: 'categories', value: a['categories'].map( c => c.label ).join(', ') } );
            }

            if ( a['attributes'] && a['attributes'].length ) {

              // space
              props.push( { key: '', value: '--' } );

              a['attributes'].forEach(element => {
                props.push ( element );
              });
            }
            this.openHover ( { show:true, accent:true, coord: entity.position._value, image: null, text: null, props: props });

            return true;
          }
          
        } else if ( type == 'line' ) {

          if ( ! props ) {
            props = this.entityHelper.getEntityProperties ( entity );
          }
          if ( ! a ) {
            if ( props.annotationRef && props.annotationRef > 0 ) {
              a = this.findAnnotation( a, props.annotationRef );
            }
          }
          if ( a ) {

            this.removeHoverEntities();
            this.createHoverLineEntities(a, props);

            // if we are creating hoverLine (ie. edge), then we need to force another drillPick() after it, so 
            // the edge detecting can happen even if you haven't moved your mouse

            this.measureHelper.checkMousePosition();


            // find the edge
            const edge = this.measureHelper.pickedModels.find(f => f.id && f.id.__type == 'edge' );
            if ( edge ) {

              // here's a quick hack (this only happens once in a blue moon, so no big penalty), but in 
              // order for the system to pick the edge over other things in the way that might get
              // picked first (ie. the line the edge was created from), I move insert the edge at the
              // beginning of the returning array

              this.measureHelper.pickedModels = [ edge, ...this.measureHelper.pickedModels ];
            }

            // console.log ( 'line hover', props, this.measureHelper.pickedModels, edge )

            this.hoverId = null;
            this.hoverCounter = 10;
            
          }
          // console.log ( ' line ', a, props );
          return true;
        }

      } else if ( type == 'edge' ) {

        let meta = entity.name.split(',');
        let annot = parseInt ( meta[0].split(':')[1] );
        // let shape = parseInt ( meta[1].split(':')[1] );
        let point = parseInt ( meta[2].split(':')[1] );

        this.selectHoverObject ( entity );

        if ( ! a ) {
          a = this.findAnnotation( a, annot );
        }
        if ( this.debug ) { console.log ( ' edge ', a, this.hoverShape.points[point] ); }
        if ( this.hoverShape.points[point]['calc'] && this.hoverShape.points[point].calc['midpoint'] ) {

          let text = '';
          if ( a['desc'] ) {
            text = text + 'Description:' + a['desc'] + '\n';
          }
          if ( this.hoverShape['calc'] && this.hoverShape.calc['length'] ) {
            text = text + 'Total length:' + this.mapHelper.getLocalisedValue ( this.hoverShape.calc['length'], a ) + '\n';
            text = text + 'Segments:' + ( this.hoverShape.points.length - 1 ) + '\n';
            }
          text = text + ' -: \nSegment:' + ( 1 + point ) + ' \n';
          text = text + this.createCalculatedText ( this.hoverShape.points[point].calc, a );
          this.openHover ({ show:true, accent:true, coord: this.hoverShape.points[point].calc.midpoint, image:null, text: a.name, props: this.createProps ( text ) });
          
          return true;
        }

      } else {

        if ( type !== 'handle' && type !== 'draghandle' && type !== 'addhandle' && type !== 'deletehandle' && type !== 'ghostline' ) {

          // does the entity have a propertyBag?
          if ( entity && entity.properties ) {

            let props = this.getEntityProperties(entity);
            props.push({key:'type',value:type});

            if ( this.cartesian && props && props.length ) {
              this.selectHoverObject ( entity );
              this.openHover ({ show:true, accent:true, coord: this.cartesian, image: null, text: null, props: props });
              return true;
            }

          } else if ( entity && entity._name && this.cartesian ) {

            this.selectHoverObject ( entity );
            this.openHover ({ show:true, accent:true, coord: this.cartesian, image: null, text: null, props: [{ key:'Name',value:entity._name},{key:'type',value:type} ] });

            return true;
          }

        }

      }

    } else {

      if ( pickedObject.primitive ) {
        
        entity = pickedObject.primitive;
        // console.log ( '@@ e', pickedObject, entity );

        let props = this.getEntityProperties(entity);
        // console.log ( '@@ else PRIMITIVE props', this.cartesian, props, entity );

        if ( this.cartesian && props && props.length ) {
          this.selectHoverObject ( entity );
          this.openHover ({ show:true, accent:true, coord: this.cartesian, image: null, text: null, props: props });
          return true;
        }
      }
      

    }

    return false;

  }

  getEntityProperties ( entity:any ) {
    let props = [];
    let p = null;

    let token = null;
    ['_properties','properties'].forEach ( t => {
      if ( entity[t] ) {
        token = t;
      }
    });

    if ( !token ) {
      return props;
    }

    // console.log('1', entity, entity._properties);
    if ( entity[token].propertyNames ) {
      entity._properties.propertyNames.forEach ( p => {
        let v = entity._properties[p]._value;
        // console.log('@ p', p, entity._properties[p]._value );
        if ( v != null || v != undefined ) {
          props.push ({ key:p, value:v });
        }
      });
    } else if ( typeof entity[token] == 'object' ) {
      Object.keys(entity[token]).forEach ( key => {
        let value = entity[token][key];
        if ( typeof value == 'object' ) {
          // console.log('@ p', key, value );
          let expand = [];
          Object.keys(value).forEach ( mkey => { 
            expand.push(mkey + ':' + value[mkey]); 
          });
          value = expand.join(', ');
        }
          props.push ({ key:key, value:value });
      });
    }
    // console.log('2',props);
    return props;
  }

  formatSize(a,b=2){if(0===a)return"0 Bytes";const c=0>b?0:b,d=Math.floor(Math.log(a)/Math.log(1024));return parseFloat((a/Math.pow(1024,d)).toFixed(c))+" "+["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][d]}

  selectHoverObject ( obj:any ) {
    this.hoverId = obj.id;
    this.hoverCounter = this.hoverCounterMax;
  }

  delayedResetHover() {
    setTimeout ( () => { this.resetHover() }, 400 );
  }

  resetHover() {
    this.hoverId = null;
    this.removeHoverEntities();
    this.mapComp.updateInfoBox ( 49, { show:false, coord: null });
    this.mapComp.refreshInfoBoxes();
    if ( this.intervalId ) {
      clearInterval(this.intervalId);
    }
  }

  openHover( config:any ) {
    //console.log ( 'pos-nav :: openHover()',config);
    this.mapComp.updateInfoBox ( 49, config );
    this.mapComp.refreshInfoBoxes();
  }

  removeHoverEntities() {
    if ( this.hoverEntities && this.hoverEntities.length ) {
      this.hoverEntities.forEach ( e => { if ( e ) { this.cesiumMapViewer.entities.remove ( e ) } });
    }
  }

  createHoverLineEntities( a:any, props:any ) {

    let shape:number = props['shapeRef'] ? props.shapeRef : 0;

    // this is only called if a and props are found
    //console.log ( 'shapeZ '+shape, a );

    // brifly check if it's a selected line (doesn't always work)
    // if ( this.mapComp.inspectorComp.selected && a.id == this.mapComp.inspectorComp.selected.id ) {
      //console.log ( 'shapeZ RETURN'+shape, a );
    //   return;
    // }

    if ( a['shapes'] && a['shapes'][shape] ) {

      // our shape
      this.hoverShape = a['shapes'][shape];

      //console.log ( 'shapeX '+shape, this.hoverShape );

      // length of our object of points
      let length = Object.keys(this.hoverShape).length

      let point_idx = -1;

      this.hoverShape.points.forEach( (point) => {

        point_idx++;
        if ( point_idx > length )
          return;

        let next = this.hoverShape['points'][point_idx + 1];

        if ( next ) {
          //console.log ( 'shapeY '+point_idx, point.coords, next.coords );

          this.hoverEntities.push(
            this.cesiumMapViewer.entities.add({
              type: 'edge',
              name: 'a:' + a.id + ',s:' + shape + ',p:' + point_idx,
              polyline: {
                positions: [ point.coords, next.coords ],
                zIndex:99,
                width: 20,
                material: Cesium.Color.WHITE.withAlpha(0.1),
                depthFailMaterial: Cesium.Color.YELLOW.withAlpha(0.01),
              },
              
            })
          );
          
        }
        

      });  

      setTimeout( () => { this.checkForHoverObjects(); }, 700 );

    } else {
      //console.log ( 'shapeQ no shape');
    }

  }

  createCalculatedText( calc:any, annotation:Annotation ) {
    
    if ( ! calc ) {
      return;
    }

    let p = calc['precission'] ? calc['precission'] : 2;
    let ret = '';
    if ( calc.volume ) { ret = ret + 'Volume:  '+ this.mapHelper.getLocalisedValue ( calc.volume, annotation ) + '\n'; }
    if ( calc.volumePos ) { ret = ret + 'Volume neg:  '+ this.mapHelper.getLocalisedValue ( calc.volumeNeg, annotation ) + '\n'; }
    if ( calc.volumeNeg ) { ret = ret + 'Volume pos:  '+ this.mapHelper.getLocalisedValue ( calc.volumePos, annotation ) + '\n'; }
    if ( calc.area ) { ret = ret + 'Area:  '+ this.mapHelper.getLocalisedValue ( calc.area, annotation ) + '\n'; }
    if ( calc.length ) { ret = ret + 'Length:  '+ this.mapHelper.getLocalisedValue ( calc.length, annotation ) + '\n'; }
    if ( calc.lengthHorizontal ) { ret = ret + 'Length hor:  '+ this.mapHelper.getLocalisedValue ( calc.lengthHorizontal, annotation ) + '\n'; }
    if ( calc.slopeVertical ) { ret = ret + 'Height diff:  '+ this.mapHelper.getLocalisedValue ( calc.slopeVertical, annotation ) + '\n'; }
    if ( calc.azimuth ) { ret = ret + 'Azimuth:  '+ calc.azimuth.toFixed(2) + ' deg\n'; }
    if ( calc.slopePercent ) { ret = ret + 'Slope:  '+ calc.slopePercent.toFixed(p)+'%'; }

    return ret;
}

  setScreenCoords(coords: any) {

    if (!coords) { return; }
    if (isNaN(coords.x)) { return; }

    if ( this.measureHelper.pickedCoord ) {
      this.cartographic = this.measureHelper.pickedCoord;
    } else {
      this.cartographic = Cesium.Cartographic.fromCartesian(coords);
      if (!this.cartographic) { return; }
    }
    
    //this.cartographic.height = this.getFeetValue(this.cartographic.height) - this.vertical_offset;

    if (this.projectedCoordinates && this.cartographic.longitude && !Number.isNaN(this.cartographic.longitude) && !Number.isNaN(this.cartographic.latitude) ) {

      try {
        let longLat = this.epsgHelper.convert(
          this.geographicProjection,
          this.sourceProjection,
          [this.cartographic.longitude, this.cartographic.latitude]
          );
        this.cartographic.longitude = longLat[0];
        this.cartographic.latitude = longLat[1];

        if ( this.mapService.cameralocation && this.showCameraCoordinates ) {
          let longLat = this.epsgHelper.convert(
            this.geographicProjection,
            this.sourceProjection,
            [this.mapService.cameralocation.longitude, this.mapService.cameralocation.latitude]
            );
          this.cartographicCamera.longitude = longLat[0];
          this.cartographicCamera.latitude = longLat[1];
        }

      } catch (error) {
        console.log('bad coord (pointer probably is pointing up into space)', this.cartographic, coords, this.measureHelper.pickedCoord );
      }

    }

    // console.log ( '===', coords, carto, this.cartographic, this.projectedCoordinates );

  }

  private getEpsgCode ( code:number ) {

  }

  private setEpsgCode(value, isId:boolean = true) {

    // reset the projected toggle
    this.projectedCoordinates = false;

    if ( this.debug ) { console.log ( 'position-nav :: setEpsgCode ('+value+')' ); }

    // assumes 'value' is always the actual EPSG code
    let q = this.epsgHelper.getCodeObjectObservable(value, 'position-nav').subscribe(sub => {

      this.sourceProjection = sub.desc;
      this.projectedCoordinates = sub.isProjected;
      
      if ( this.debug ) { console.log ( 'position-nav :: setEpsgCode ('+value+') final', sub, this.projectedCoordinates ); }
    });
/*
    let q = this.fourD.V.api('/epsg/7686786876786').subscribe(res => {
      console.log ( 'setCode('+value+')', res);
      // this.geographicProjection = res;
    });

    let search = this.fourD.V.searchByObject(EPSGCodes).equals('uid', value);
    if (!isId) {
      search = this.fourD.V.searchByObject(EPSGCodes).contains('name', value);
    }

    if ( this.debug ) { console.log ( '%c position-nav :: setEpsgCode()', Constants._yellow, value, isId, search ); }

    search.queryObservable().subscribe(value1 => {


      if ( value1.items && value1.items.length > 0 ) {

        if ( this.debug ) { console.log ( '%c position-nav :: setEpsgCode() :: result =', Constants._yellow, value1.items.length, value1 ); }


        this.sourceProjection = value1.items[0].desc;
        this.selectedEPSG = value1.items[0].uid;
        // this.csrtype = projected then dont show W and S
        this.CSRType = value1.items[0].CSRType;

        if ( this.CSRType.trim().toLowerCase() == 'projected' ) {
          this.projectedCoordinates = true;
        } else {
          this.projectedCoordinates = false;
        }


        //x = long , y= lat
      } else {

        if ( this.debug ) { console.log ( '%c position-nav :: setEpsgCode() :: NO result', Constants._yellow, value1 ); }

        this.projectedCoordinates = false;
        this.CSRType = null;
      }



    });
    */
  }

  public getFeetValue(value: any) {

    if (this.measurementUnit === MapService.FEET) {
      value = value / 0.3048;
    }
    return value;
  }

  

  private setMUnitAndEPSGCode() {

    const project = this.mapService ? this.mapService.currentProject : null;
    let units = MapService.METER;
    let epsg = '4326';

    if ( this.debug ) { console.log ( '%c position-nav :: setMUnitAndEPSGCode() INIT', Constants._yellow, this.mapComp, project ); }


    if ( project ) {
      if ( this.debug ) { console.log ( '%c position-nav :: setMUnitAndEPSGCode() HAS_PROJECT', Constants._yellow ); }
      if ( project['measurementUnit'] ) {
        if ( this.debug ) { console.log ( '%c position-nav :: setMUnitAndEPSGCode() HAS_UNITS', Constants._yellow ); }
        units = project['measurementUnit'];
      }
      if ( project['EPSGCode'] ) {
        if ( this.debug ) { console.log ( '%c position-nav :: setMUnitAndEPSGCode() HAS_EPSG_CODE', Constants._yellow ); }
        epsg = project['EPSGCode'];
      }
    } else {
      if ( this.debug ) { console.log ( '%c position-nav :: setMUnitAndEPSGCode() NO_PROJECT', Constants._yellow ); }
    }

    this.measurementUnit = units;
    this.setEpsgCode(epsg);

    /*
    if ( this.debug ) { console.log ( '%c position-nav :: setMUnitAndEPSGCode()', Constants._yellow, this.mapComp ? "HAS_MAPCOMP":"NO_MAPCOMP", project ?"HAS_PROJECT":"NO_PROJECT", this.mapComp ); }

    if (this.mapComp.project && this.mapComp.project['measurementUnit']) {
      // if ( this.debug ) { console.log ( '%c position-nav :: setMUnitAndEPSGCode()', Constants._yellow, this.mapComp.project['measurementUnit'] ?"HAS_MEASUREMENTS":"NO_MEASUREMENTS" ); }
      this.measurementUnit = this.mapComp.project['measurementUnit'];
    } else {
      this.measurementUnit = MapService.METER;
    }
    if ( this.mapComp.project && this.mapComp.project['EPSGCode']) {
      // if ( this.debug ) { console.log ( '%c position-nav :: setMUnitAndEPSGCode()', Constants._yellow, this.mapComp.project['EPSGCode'] ?"HAS_EPSG_"+this.mapComp.project['EPSGCode'] :"NO_EPSG" ); }
      this.setEpsgCode(this.mapComp.project['EPSGCode']);
    } else {
      this.setEpsgCode('4326');
    }
    */
  }










  deviceOrientationHandler( evnt ) {

    if ( this.fourD && this.fourD.activeUser && this.fourD.activeUser['showLocation'] && this.fourD.activeUser['useLocation'] ) {

      var beta = evnt.beta;
      var gamma = evnt.gamma;
      var alpha = evnt.alpha; 
      
      var matrix = this.computeMatrix(alpha, beta, gamma, this.currentScreenOrientation);
      var YawPitchRoll = this.getYawPitchRoll(matrix);

      this.cesiumMapViewer.camera.setView({
        position: new Cesium.Cartesian3.fromDegrees(
          this.mapService.geolocation.longitude,
          this.mapService.geolocation.latitude,
          this.mapService.geolocation.height ? this.mapService.geolocation.height : ( this.mapService.geolocation.sampledHeight ? this.mapService.geolocation.sampledHeight : this.mapService.geolocation.cameraHeight ) 
        ),
        orientation : {
          heading : -YawPitchRoll[0],
          pitch : YawPitchRoll[1],
          roll: -YawPitchRoll[2]
        }
      });
    }
  }



  /**
* Rotation Matrix functions
* Convert Yaw/alpha/Z, Pitch/beta/X, Roll/gamma/Y to and from rotation matrix, apply transformations
*
* @author Rich Tibbett <https://dev.opera.com/articles/w3c-device-orientation-usage/>, Nghia Ho <http://nghiaho.com/?page_id=846>, Derek Wee
* @copyright 
* @version 0.1
* @license 
*/


  degtorad = Math.PI / 180; // Degree-to-Radian conversion

  //R.1: Converting deviceorientation angles to a Rotation Matrix representation
  getBaseRotationMatrix( alpha, beta, gamma ) {
    var _x = beta  ? beta  * this.degtorad : 0; // beta value
    var _y = gamma ? gamma * this.degtorad : 0; // gamma value
    var _z = alpha ? alpha * this.degtorad : 0; // alpha value

    var cX = Math.cos( _x );
    var cY = Math.cos( _y );
    var cZ = Math.cos( _z );
    var sX = Math.sin( _x );
    var sY = Math.sin( _y );
    var sZ = Math.sin( _z );

    //
    // ZXY-ordered rotation matrix construction.
    //

    var m11 = cZ * cY - sZ * sX * sY;
    var m12 = - cX * sZ;
    var m13 = cY * sZ * sX + cZ * sY;

    var m21 = cY * sZ + cZ * sX * sY;
    var m22 = cZ * cX;
    var m23 = sZ * sY - cZ * cY * sX;

    var m31 = - cX * sY;
    var m32 = sX;
    var m33 = cX * cY;

    return [
    m11,    m12,    m13,
    m21,    m22,    m23,
    m31,    m32,    m33
    ];
  }

  //R.2: Fixing our rotation matrix frame relative to the current screen orientation
  getScreenTransformationMatrix( screenOrientation ) {
    var orientationAngle = screenOrientation ? screenOrientation * this.degtorad : 0;

    var cA = Math.cos( orientationAngle );
    var sA = Math.sin( orientationAngle );

    // Construct our screen transformation matrix
    var r_s = [
    cA,    -sA,    0,
    sA,    cA,     0,
    0,     0,      1
    ];

    return r_s;
  }

  //R.3: Fix our rotation matrix frame relative to our application’s world orientation (rotation around x-axis)
  getWorldTransformationMatrix() {

    // Alex says: I suspect somewhere in here in non-southern hemisphere compatibility
    
    var x = -90 * this.degtorad;

    var cA = Math.cos( x );
    var sA = Math.sin( x );

    // Construct our world transformation matrix
    var r_w = [
    1,     0,    0,
    0,     cA,   -sA,
    0,     sA,   cA
    ];

    return r_w;
  }


  //R.4: Computing our final rotation matrix representation
  matrixMultiply( a, b ) {
    var final = [];

    final[0] = a[0] * b[0] + a[1] * b[3] + a[2] * b[6];
    final[1] = a[0] * b[1] + a[1] * b[4] + a[2] * b[7];
    final[2] = a[0] * b[2] + a[1] * b[5] + a[2] * b[8];

    final[3] = a[3] * b[0] + a[4] * b[3] + a[5] * b[6];
    final[4] = a[3] * b[1] + a[4] * b[4] + a[5] * b[7];
    final[5] = a[3] * b[2] + a[4] * b[5] + a[5] * b[8];

    final[6] = a[6] * b[0] + a[7] * b[3] + a[8] * b[6];
    final[7] = a[6] * b[1] + a[7] * b[4] + a[8] * b[7];
    final[8] = a[6] * b[2] + a[7] * b[5] + a[8] * b[8];

    return final;
  }

  //Returns a 3 x 3 rotation matrix as an array
  computeMatrix(alpha, beta, gamma, currentScreenOrientation) {
    var rotationMatrix = this.getBaseRotationMatrix(
    alpha,
    beta,
    gamma
    ); // R

    var screenTransform = this.getScreenTransformationMatrix( currentScreenOrientation ); // r_s

    var screenAdjustedMatrix = this.matrixMultiply( rotationMatrix, screenTransform ); // R_s

    var worldTransform = this.getWorldTransformationMatrix(); // r_w

    var finalMatrix = this.matrixMultiply( screenAdjustedMatrix, worldTransform ); // R_w
      
    return finalMatrix; // [ m11, m12, m13, m21, m22, m23, m31, m32, m33 ]
  }

  getYawPitchRoll(rotationMatrix) {
    var rm11 = rotationMatrix[0]; var rm12 = rotationMatrix[1]; var rm13 = rotationMatrix[2];
    var rm21 = rotationMatrix[3]; var rm22 = rotationMatrix[4]; var rm23 = rotationMatrix[5];
    var rm31 = rotationMatrix[6]; var rm32 = rotationMatrix[7]; var rm33 = rotationMatrix[8];
    
    var yaw = Math.atan2(rm21, rm11);
    var pitch = Math.atan2(rm32, rm33);
    var roll = Math.atan2(rm31, Math.sqrt(Math.pow(rm32,2) + Math.pow(rm33,2)));
    
    return [yaw, pitch, roll]; //[yaw, pitch, roll]
  }

}
